import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable'

//UI
import { camelToWords } from '@/utils/stringHelper'
import { Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import ColumnMenuItem from './ColumnMenuItem'
const AppliedColumnCard = ({ columns, setColumns, handleRemoveColumn }) => {
  const { t } = useTranslation()

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  const handleDragEnd = (event) => {
    const { active, over } = event

    if (active.id !== over.id) {
      setColumns((items) => {
        const oldIndex = items.findIndex((item) => item.id === active.id)
        const newIndex = items.findIndex((item) => item.id === over.id)

        return arrayMove(items, oldIndex, newIndex)
      })
    }
  }
  return (
    <Card w="50%" overflowY={'scroll'}>
      <Flex direction={'column'} px={3}>
        <CardHeader>
          <Heading size="md">{t('TABLE_APPLIED_COLUMN')}</Heading>
        </CardHeader>
        <CardBody>
          <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={columns} strategy={verticalListSortingStrategy}>
              {columns.map((column) => (
                <ColumnMenuItem
                  key={column.id}
                  id={column.id}
                  canRemove={column.getCanHide()}
                  handleRemoveColumn={() => handleRemoveColumn(column)}
                >
                  {column.columnDef.header()}
                </ColumnMenuItem>
              ))}
            </SortableContext>
          </DndContext>
        </CardBody>
      </Flex>
    </Card>
  )
}

export default AppliedColumnCard
